<template>

  <b-button 
    :type="bButtonType" 
    :variant="bButtonVariant" 
    :block="block" 
    size="sm"
    @click="handleClick"
  >
    <i :class="iClass"></i>
    <span class="text-uppercase button-span" >
      {{label}}
    </span>
  </b-button>

</template>

<script>


export default {
  name: 'Button',
  props: {
    label: {
      type: String,
      required: true,
    },
    customType: {
      type: String,
      validator: function (value) {
        // El valor debe coincidir con una de estas cadenas de texto
        return ['submit', 'reset', 'exit'].indexOf(value) !== -1
      }
    },
    block:{
      type: Boolean, 
      default: false
    }, 
    type: {
      type: String
    },
    variant: {
      type: String
    },
    iconClass: {
      type: String
    }
  },
  data () {
    return {
      bButtonType: "", 
      bButtonVariant: "", 
      iClass: ""
    }
  },
  computed: {
  },
  watch: {
  }, 
  mounted() {

    this.bButtonType = this.type;
    this.bButtonVariant = this.variant;
    this.iClass = this.iconClass;

    if(this.customType){
      switch (this.customType) {
        case 'submit':
          this.bButtonType = "submit";
          this.bButtonVariant = "success";
          this.iClass = "fas fa-edit";
          break;
        case 'reset':
          this.bButtonType = "reset";
          this.bButtonVariant = "warning";
          this.iClass = "fas fa-undo-alt";
          break;
        case 'exit':
          this.bButtonType = "button";
          this.bButtonVariant = "danger";
          this.iClass = "fas fa-arrow-left";
          break;
        case 'return':
          this.bButtonType = "button";
          this.bButtonVariant = "info";
          this.iClass = "fas fa-arrow-left";
          break;
        default:
          this.bButtonType = "";
          this.bButtonVariant = "";
          this.iClass = "";
      }
    }
  },
  methods: {
    handleClick() {
      this.$emit("click");
    }
  }
}

</script>

<style scoped>
.button-span{
  font-size:12px;
  font-weight:bold;
  margin-left:5px
}
</style>